export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const RESEND_EMAIL_SUCCESS = "RESEND_EMAIL_SUCCESS";
export const RESEND_EMAIL_FAIL = "RESEND_EMAIL_FAIL";

export const GLOBAL_SEARCH_SUCCESS = "GLOBAL_SEARCH_SUCCESS";
export const GLOBAL_SEARCH_FAIL = "GLOBAL_SEARCH_FAIL";

export const CART_START = "CART_START";
export const CART_SUCCESS = "CART_SUCCESS";
export const CART_FAIL = "CART_FAIL";

export const OPEN_ADD_CHAT_POPUP = "OPEN_ADD_CHAT_POPUP";
export const CLOSE_ADD_CHAT_POPUP = "CLOSE_ADD_CHAT_POPUP";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const SET_MESSAGES = "SET_MESSAGES";
export const SET_STATUS = "SET_STATUS";
export const SET_UNVIEWS = "SET_UNVIEWS";
export const GET_CHATS_SUCCESS = "GET_CHATS_SUCCESS";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const ADD_MSGS = "ADD_MSGS";
export const SET_MSGS = "SET_MSGS";

export const SET_BOARD_ORDER = "SET_BOARD_ORDER"
export const SET_CARD_ORDER = "SET_CARD_ORDER"
export const SET_CARD_DETAILS = "SET_CARD_DETAILS"
export const SET_LASTVIEWED = "SET_LASTVIEWED"
export const GET_CARD_DETAILS = "GET_CARD_DETAILS"

export const GET_USER_START = "GET_USER_START";
export const GET_USER_FAIL = "GET_USER_FAIL";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";

export const GET_USER_PROFILE_INFO_START = "GET_USER_PROFILE_INFO_START";
export const GET_USER_PROFILE_INFO_FAIL = "GET_USER_PROFILE_INFO_FAIL";
export const GET_USER_PROFILE_INFO_SUCCESS = "GET_USER_PROFILE_INFO_SUCCESS";

export const GET_PROFILE_RESUME_START = "GET_PROFILE_RESUME_START";
export const GET_PROFILE_RESUME_FAIL = "GET_PROFILE_RESUME_FAIL";
export const GET_PROFILE_RESUME_SUCCESS = "GET_PROFILE_RESUME_SUCCESS";

export const PUT_PROFILE_RESUME_START = "PUT_PROFILE_RESUME_START";
export const PUT_PROFILE_RESUME_SUCCESS = "PUT_PROFILE_RESUME_SUCCESS";
export const PUT_PROFILE_RESUME_FAIL = "PUT_PROFILE_RESUME_FAIL";

export const GET_LIKES_START = "LIKES_START";
export const GET_LIKES_FAIL = "LIKES_FAIL";
export const GET_LIKES_SUCCESS = "LIKES_SUCCESS";

export const GET_LIKE_DETAIL_START = "GET_LIKE_DETAIL_START";
export const GET_LIKE_DETAIL_FAIL = "GET_LIKE_DETAIL_FAIL";
export const GET_LIKE_DETAIL_SUCCESS = "GET_LIKE_DETAIL_SUCCESS";

export const LIKE_START = "LIKE_START";
export const LIKE_FAIL = "LIKE_FAIL";
export const LIKE_SUCCESS = "LIKE_SUCCESS";

export const GET_PROJECT_LIKES_START = "PROJECT_LIKES_START";
export const GET_PROJECT_LIKES_FAIL = "PROJECT_LIKES_FAIL";
export const GET_PROJECT_LIKES_SUCCESS = "PROJECT_LIKES_SUCCESS";

export const GET_PROJECT_LIKE_DETAIL_START = "GET_PROJECT_LIKE_DETAIL_START";
export const GET_PROJECT_LIKE_DETAIL_FAIL = "GET_PROJECT_LIKE_DETAIL_FAIL";
export const GET_PROJECT_LIKE_DETAIL_SUCCESS = "GET_PROJECT_LIKE_DETAIL_SUCCESS";

export const PROJECT_LIKE_START = "PROJECT_LIKE_START";
export const PROJECT_LIKE_FAIL = "PROJECT_LIKE_FAIL";
export const PROJECT_LIKE_SUCCESS = "PROJECT_LIKE_SUCCESS";

export const GET_RATING_START = "GET_RATING_START";
export const GET_RATING_FAIL = "GET_RATING_FAIL";
export const GET_RATING_SUCCESS = "GET_RATING_SUCCESS";

export const CREATE_RATING_START = "CREATE_RATING_START";
export const CREATE_RATING_FAIL = "CREATE_RATING_FAIL";
export const CREATE_RATING_SUCCESS = "CREATE_RATING_SUCCESS";

export const GET_ROOM_DETAIL_START = "GET_ROOM_DETAIL_START";
export const GET_ROOM_DETAIL_FAIL = "GET_ROOM_DETAIL_FAIL";
export const GET_ROOM_DETAIL_SUCCESS = "GET_ROOM_DETAIL_SUCCESS";

export const PUT_ROOM_DETAIL_START = "PUT_ROOM_DETAIL_START"
export const PUT_ROOM_DETAIL_FAIL = "PUT_ROOM_DETAIL_FAIL"
export const PUT_ROOM_DETAIL_SUCCESS = "PUT_ROOM_DETAIL_SUCCESS"

export const CREATE_COMMENT_START = "CREATE_COMMENT_START";
export const CREATE_COMMENT_FAIL = "CREATE_COMMENT_FAIL";
export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS";

export const GET_COMMENT_LIST_START = "GET_COMMENT_LIST_START";
export const GET_COMMENTS_LIST_FAIL = "GET_COMMENTS_LIST_FAIL";
export const GET_COMMENTS_LIST_SUCCESS = "GET_COMMENTS_LIST_SUCCESS";

export const GET_COMMENT_DETAIL_START = "GET_COMMENT_DETAIL_START";
export const GET_COMMENT_DETAIL_FAIL = "GET_COMMENT_DETAIL_FAIL";
export const GET_COMMENT_DETAIL_SUCCESS = "GET_COMMENT_DETAIL_SUCCESS";

export const PUT_COMMENT_START = "PUT_COMMENT_START,";
export const PUT_COMMENT_FAIL = "PUT_COMMENT_FAIL,";
export const PUT_COMMENT_SUCCESS = "PUT_COMMENT_SUCCESS";

export const CREATE_PROJECT_COMMENT_START = "CREATE_PROJECT_COMMENT_START";
export const CREATE_PROJECT_COMMENT_FAIL = "CREATE_PROJECT_COMMENT_FAIL";
export const CREATE_PROJECT_COMMENT_SUCCESS = "CREATE_PROJECT_COMMENT_SUCCESS";

export const GET_PROJECT_COMMENT_LIST_START = "GET_PROJECT_COMMENT_LIST_START";
export const GET_PROJECT_COMMENTS_LIST_FAIL = "GET_PROJECT_COMMENTS_LIST_FAIL";
export const GET_PROJECT_COMMENTS_LIST_SUCCESS = "GET_PROJECT_COMMENTS_LIST_SUCCESS";

export const GET_PROJECT_COMMENT_DETAIL_START = "GET_PROJECT_COMMENT_DETAIL_START";
export const GET_PROJECT_COMMENT_DETAIL_FAIL = "GET_PROJECT_COMMENT_DETAIL_FAIL";
export const GET_PROJECT_COMMENT_DETAIL_SUCCESS = "GET_PROJECT_COMMENT_DETAIL_SUCCESS";

export const PUT_PROJECT_COMMENT_START = "PUT_PROJECT_COMMENT_START,";
export const PUT_PROJECT_COMMENT_FAIL = "PUT_PROJECT_COMMENT_FAIL,";
export const PUT_PROJECT_COMMENT_SUCCESS = "PUT_PROJECT_COMMENT_SUCCESS";

export const CREATE_ARTICLE_START = "CREATE_ARTICLE_START";
export const CREATE_ARTICLE_FAIL = "CREATE_ARTICLE_FAIL";
export const CREATE_ARTICLE_SUCCESS = "CREATE_ARTICLE_SUCCESS";

export const GET_ARTICLE_LIST_START = "GET_ARTICLE_LIST_START";
export const GET_ARTICLES_LIST_FAIL = "GET_ARTICLES_LIST_FAIL";
export const GET_ARTICLES_LIST_SUCCESS = "GET_ARTICLES_LIST_SUCCESS";

export const GET_ARTICLE_DETAIL_START = "GET_ARTICLE_DETAIL_START";
export const GET_ARTICLE_DETAIL_FAIL = "GET_ARTICLE_DETAIL_FAIL";
export const GET_ARTICLE_DETAIL_SUCCESS = "GET_ARTICLE_DETAIL_SUCCESS";

export const CREATE_WORKSHOP_START = "CREATE_WORKSHOP_START";
export const CREATE_WORKSHOP_FAIL = "CREATE_WORKSHOP_FAIL";
export const CREATE_WORKSHOP_SUCCESS = "CREATE_WORKSHOP_SUCCESS";

export const GET_WORKSHOP_LIST_START = "GET_WORKSHOP_LIST_START";
export const GET_WORKSHOPS_LIST_FAIL = "GET_WORKSHOPS_LIST_FAIL";
export const GET_WORKSHOPS_LIST_SUCCESS = "GET_WORKSHOPS_LIST_SUCCESS";

export const GET_WORKSHOP_DETAIL_START = "GET_WORKSHOP_DETAIL_START";
export const GET_WORKSHOP_DETAIL_FAIL = "GET_WORKSHOP_DETAIL_FAIL";
export const GET_WORKSHOP_DETAIL_SUCCESS = "GET_WORKSHOP_DETAIL_SUCCESS";

export const CREATE_PROJECT_START = "CREATE_PROJECT_START";
export const CREATE_PROJECT_FAIL = "CREATE_PROJECT_FAIL";
export const CREATE_PROJECT_SUCCESS = "CREATE_PROJECT_SUCCESS";

export const GET_PROJECT_LIST_START = "GET_PROJECT_LIST_START";
export const GET_PROJECTS_LIST_FAIL = "GET_PROJECTS_LIST_FAIL";
export const GET_PROJECTS_LIST_SUCCESS = "GET_PROJECTS_LIST_SUCCESS";

export const GET_PROJECT_DETAIL_START = "GET_PROJECT_DETAIL_START";
export const GET_PROJECT_DETAIL_FAIL = "GET_PROJECT_DETAIL_FAIL";
export const GET_PROJECT_DETAIL_SUCCESS = "GET_PROJECT_DETAIL_SUCCESS";

export const GET_ASSIGNMENT_LIST_START = "GET_ASSIGNMENT_LIST_START";
export const GET_ASSIGNMENTS_LIST_FAIL = "GET_ASSIGNMENTS_LIST_FAIL";
export const GET_ASSIGNMENTS_LIST_SUCCESS = "GET_ASSIGNMENTS_LIST_SUCCESS";

export const GET_ASSIGNMENT_DETAIL_START = "GET_ASSIGNMENT_DETAIL_START";
export const GET_ASSIGNMENT_DETAIL_FAIL = "GET_ASSIGNMENT_DETAIL_FAIL";
export const GET_ASSIGNMENT_DETAIL_SUCCESS = "GET_ASSIGNMENT_DETAIL_SUCCESS";

export const GET_ASSIGNMENT_CHOICES_START = "GET_ASSIGNMENT_CHOICES_START";
export const GET_ASSIGNMENTS_CHOICES_FAIL = "GET_ASSIGNMENTS_CHOICES_FAIL";
export const GET_ASSIGNMENTS_CHOICES_SUCCESS = "GET_ASSIGNMENTS_CHOICES_SUCCESS";

export const CREATE_ASSIGNMENT_START = "CREATE_ASSIGNMENT_START";
export const CREATE_ASSIGNMENT_FAIL = "CREATE_ASSIGNMENT_FAIL";
export const CREATE_ASSIGNMENT_SUCCESS = "CREATE_ASSIGNMENT_SUCCESS";

export const GET_GRADED_ASSIGNMENT_LIST_START = "GET_GRADED_ASSIGNMENT_LIST_START";
export const GET_GRADED_ASSIGNMENTS_LIST_FAIL = "GET_GRADED_ASSIGNMENTS_LIST_FAIL";
export const GET_GRADED_ASSIGNMENTS_LIST_SUCCESS = "GET_GRADED_ASSIGNMENTS_LIST_SUCCESS";

export const CREATE_MEETING_START = "CREATE_MEETING_START";
export const CREATE_MEETING_FAIL = "CREATE_MEETING_FAIL";
export const CREATE_MEETING_SUCCESS = "CREATE_MEETING_SUCCESS";

export const GET_MEETING_LIST_START = "GET_MEETING_LIST_START";
export const GET_MEETINGS_LIST_FAIL = "GET_MEETINGS_LIST_FAIL";
export const GET_MEETINGS_LIST_SUCCESS = "GET_MEETINGS_LIST_SUCCESS";

export const GET_RECEVIED_MEETING_LIST_START = "GET_RECEVIED_MEETING_LIST_START";
export const GET_RECEVIED_MEETINGS_LIST_SUCCESS = "GET_RECEVIED_MEETINGS_LIST_FAIL";
export const GET_RECEVIED_MEETINGS_LIST_FAIL = "GET_RECEVIED_MEETINGS_LIST_SUCCESS";

export const GET_BOOKED_MEETING_LIST_START = "GET_BOOKED_MEETING_LIST_START";
export const GET_BOOKED_MEETINGS_LIST_SUCCESS = "GET_BOOKED_MEETINGS_LIST_SUCCESS";
export const GET_BOOKED_MEETINGS_LIST_FAIL = "GET_BOOKED_MEETINGS_LIST_FAIL";

export const GET_MEETING_DETAIL_START = "GET_MEETING_DETAIL_START";
export const GET_MEETING_DETAIL_FAIL = "GET_MEETING_DETAIL_FAIL";
export const GET_MEETING_DETAIL_SUCCESS = "GET_MEETING_DETAIL_SUCCESS";

export const PUT_MEETING_DETAIL_START = "PUT_MEETING_DETAIL_START";
export const PUT_MEETING_DETAIL_SUCCESS = "PUT_MEETING_DETAIL_SUCCESS";
export const PUT_MEETING_DETAIL_FAIL = "PUT_MEETING_DETAIL_FAIL";

export const CANCEL_MEETING_START = "CANCEL_MEETING_START,";
export const CANCEL_MEETING_FAIL = "CANCEL_MEETING_FAIL,";
export const CANCEL_MEETING_SUCCESS = "CANCEL_MEETING_SUCCESS";

export const GET_PROFILE_PAGE_START = "GET_PROFILE_PAGE_START";
export const GET_PROFILE_PAGE_FAIL = "GET_PROFILE_PAGE_FAIL";
export const GET_PROFILE_PAGE_SUCCESS = "GET_PROFILE_PAGE_SUCCESS";

export const GET_PROFILE_DETAIL_START = "GET_PROFILE_DETAIL_START";
export const GET_PROFILE_DETAIL_FAIL = "GET_PROFILE_DETAIL_FAIL";
export const GET_PROFILE_DETAIL_SUCCESS = "GET_PROFILE_DETAIL_SUCCESS";

export const GET_PROFILE_ACCOUNT_DETAIL_START = "GET_PROFILE_ACCOUNT_DETAIL_START";
export const GET_PROFILE_ACCOUNT_DETAIL_FAIL = "GET_PROFILE_ACCOUNT_DETAIL_FAIL";
export const GET_PROFILE_ACCOUNT_DETAIL_SUCCESS = "GET_PROFILE_ACCOUNT_DETAIL_SUCCESS";

export const PUT_PROFILE_ACCOUNT_DETAIL_START = "PUT_PROFILE_ACCOUNT_DETAIL_START";
export const PUT_PROFILE_ACCOUNT_DETAIL_SUCCESS = "PUT_PROFILE_ACCOUNT_DETAIL_SUCCESS";
export const PUT_PROFILE_ACCOUNT_DETAIL_FAIL = "PUT_PROFILE_ACCOUNT_DETAIL_FAIL";

export const GET_PROFILE_MR_START = "GET_PROFILE_MR_START"
export const GET_PROFILE_MR_FAIL = "GET_PROFILE_MR_FAIL"
export const GET_PROFILE_MR_SUCCESS = "GET_PROFILE_MR_SUCCESS"

export const GET_PROFILE_INFO_START = "GET_PROFILE_INFO_START";
export const GET_PROFILE_INFO_FAIL = "GET_PROFILE_INFO_FAIL";
export const GET_PROFILE_INFO_SUCCESS = "GET_PROFILE_INFO_SUCCESS";

export const PUT_PROFILE_INFO_START = "PUT_PROFILE_INFO_START";
export const PUT_PROFILE_INFO_SUCCESS = "PUT_PROFILE_INFO_SUCCESS";
export const PUT_PROFILE_INFO_FAIL = "PUT_PROFILE_INFO_FAIL";

export const GET_PROFILE_ARTICLE_LIST_START = "GET_PROFILE_ARTICLE_LIST_START";
export const GET_PROFILE_ARTICLES_LIST_FAIL = "GET_PROFILE_ARTICLES_LIST_FAIL";
export const GET_PROFILE_ARTICLES_LIST_SUCCESS = "GET_PROFILE_ARTICLES_LIST_SUCCESS";

export const GET_PROFILE_ARTICLE_DETAIL_START = "GET_PROFILE_ARTICLE_DETAIL_START";
export const GET_PROFILE_ARTICLE_DETAIL_FAIL = "GET_PROFILE_ARTICLE_DETAIL_FAIL";
export const GET_PROFILE_ARTICLE_DETAIL_SUCCESS = "GET_PROFILE_ARTICLE_DETAIL_SUCCESS";

export const PUT_PROFILE_ARTICLE_DETAIL_START = "PUT_PROFILE_ARTICLE_DETAIL_START";
export const PUT_PROFILE_ARTICLE_DETAIL_FAIL = "PUT_PROFILE_ARTICLE_DETAIL_FAIL";
export const PUT_PROFILE_ARTICLE_DETAIL_SUCCESS = "PUT_PROFILE_ARTICLE_DETAIL_SUCCESS";

export const DELETE_PROFILE_ARTICLE_DETAIL_FAIL = "DELETE_PROFILE_ARTICLE_DETAIL_FAIL";
export const DELETE_PROFILE_ARTICLE_DETAIL_SUCCESS = "DELETE_PROFILE_ARTICLE_DETAIL_SUCCESS";

export const GET_PROFILE_PROJECT_LIST_START = "GET_PROFILE_PROJECT_LIST_START";
export const GET_PROFILE_PROJECTS_LIST_FAIL = "GET_PROFILE_PROJECTS_LIST_FAIL";
export const GET_PROFILE_PROJECT_LIST_FAIL = "GET_PROFILE_PROJECTS_LIST_FAIL";
export const GET_PROFILE_PROJECT_LIST_SUCCESS = "GET_PROFILE_PROJECTS_LIST_SUCCESS";
export const GET_PROFILE_PROJECTS_LIST_SUCCESS = "GET_PROFILE_PROJECTS_LIST_SUCCESS";

export const GET_PROFILE_PROJECT_DETAIL_START = "GET_PROFILE_PROJECT_DETAIL_START";
export const GET_PROFILE_PROJECT_DETAIL_FAIL = "GET_PROFILE_PROJECT_DETAIL_FAIL";
export const GET_PROFILE_PROJECT_DETAIL_SUCCESS = "GET_PROFILE_PROJECT_DETAIL_SUCCESS";

export const PUT_PROFILE_PROJECT_DETAIL_START = "PUT_PROFILE_PROJECT_DETAIL_START";
export const PUT_PROFILE_PROJECT_DETAIL_FAIL = "PUT_PROFILE_PROJECT_DETAIL_FAIL";
export const PUT_PROFILE_PROJECT_DETAIL_SUCCESS = "PUT_PROFILE_PROJECT_DETAIL_SUCCESS";

export const DELETE_PROFILE_PROJECT_DETAIL_FAIL = "DELETE_PROFILE_PROJECT_DETAIL_FAIL";
export const DELETE_PROFILE_PROJECT_DETAIL_SUCCESS = "DELETE_PROFILE_PROJECT_DETAIL_SUCCESS";

export const CREATE_INCENTIVE_START = "CREATE_INCENTIVE_START";
export const CREATE_INCENTIVE_FAIL = "CREATE_INCENTIVE_FAIL";
export const CREATE_INCENTIVE_SUCCESS = "CREATE_INCENTIVE_SUCCESS";

export const GET_INCENTIVE_LIST_START = "GET_INCENTIVE_LIST_START";
export const GET_INCENTIVE_LIST_SUCCESS = "GET_INCENTIVE_LIST_SUCCESS";
export const GET_INCENTIVE_LIST_FAIL = "GET_INCENTIVE_LIST_FAIL";

export const GET_INCENTIVE_DETAIL_START = "GET_INCENTIVE_DETAIL_START";
export const GET_INCENTIVE_DETAIL_FAIL = "GET_INCENTIVE_DETAIL_FAIL";
export const GET_INCENTIVE_DETAIL_SUCCESS = "GET_INCENTIVE_DETAIL_SUCCESS";

export const CREATE_MEETING_REVIEW_DETAIL_START = "CREATE_MEETING_REVIEW_DETAIL_START";
export const CREATE_MEETING_REVIEW_DETAIL_SUCCESS = "CREATE_MEETING_REVIEW_DETAIL_SUCCESS";
export const CREATE_MEETING_REVIEW_DETAIL_FAIL = "CREATE_MEETING_REVIEW_DETAIL_FAIL";

export const GET_SURVEY_LIST_START = "GET_SURVEY_LIST_START";
export const GET_SURVEYS_LIST_FAIL = "GET_SURVEYS_LIST_FAIL";
export const GET_SURVEYS_LIST_SUCCESS = "GET_SURVEYS_LIST_SUCCESS";

export const GET_SURVEY_DETAIL_START = "GET_SURVEY_DETAIL_START";
export const GET_SURVEY_DETAIL_FAIL = "GET_SURVEY_DETAIL_FAIL";
export const GET_SURVEY_DETAIL_SUCCESS = "GET_SURVEY_DETAIL_SUCCESS";

export const GET_SURVEY_CHOICES_START = "GET_SURVEY_CHOICES_START";
export const GET_SURVEYS_CHOICES_FAIL = "GET_SURVEYS_CHOICES_FAIL";
export const GET_SURVEYS_CHOICES_SUCCESS = "GET_SURVEYS_CHOICES_SUCCESS";

export const CREATE_SURVEY_START = "CREATE_SURVEY_START";
export const CREATE_SURVEY_FAIL = "CREATE_SURVEY_FAIL";
export const CREATE_SURVEY_SUCCESS = "CREATE_SURVEY_SUCCESS";

export const GET_GRADED_SURVEY_LIST_START = "GET_GRADED_SURVEY_LIST_START";
export const GET_GRADED_SURVEYS_LIST_FAIL = "GET_GRADED_SURVEYS_LIST_FAIL";
export const GET_GRADED_SURVEYS_LIST_SUCCESS = "GET_GRADED_SURVEYS_LIST_SUCCESS";

export const GET_GRADED_SURVEY_DETAIL_START = "GET_GRADED_SURVEY_DETAIL_START"
export const GET_GRADED_SURVEYS_DETAIL_SUCCESS = "GET_GRADED_SURVEYS_DETAIL_SUCCESS"
export const GET_GRADED_SURVEYS_DETAIL_FAIL = "GET_GRADED_SURVEYS_DETAIL_FAIL"

export const GET_PROFILE_SURVEY_LIST_START = "GET_PROFILE_SURVEY_LIST_START";
export const GET_PROFILE_SURVEY_LIST_SUCCESS = "GET_PROFILE_SURVEY_LIST_SUCCESS";
export const GET_PROFILE_SURVEY_LIST_FAIL = "GET_PROFILE_SURVEY_LIST_FAIL";
export const GET_PROFILE_SURVEY_DETAIL_START = "GET_PROFILE_SURVEY_DETAIL_START";
export const GET_PROFILE_SURVEY_DETAIL_FAIL = "GET_PROFILE_SURVEY_DETAIL_FAIL";
export const GET_PROFILE_SURVEY_DETAIL_SUCCESS = "GET_PROFILE_SURVEY_DETAIL_SUCCESS";
export const PUT_PROFILE_SURVEY_DETAIL_START = "PUT_PROFILE_SURVEY_DETAIL_START";
export const PUT_PROFILE_SURVEY_DETAIL_FAIL = "PUT_PROFILE_SURVEY_DETAIL_FAIL";
export const PUT_PROFILE_SURVEY_DETAIL_SUCCESS = "PUT_PROFILE_SURVEY_DETAIL_SUCCESS";
export const DELETE_PROFILE_SURVEY_DETAIL_FAIL = "DELETE_PROFILE_SURVEY_DETAIL_FAIL";
export const DELETE_PROFILE_SURVEY_DETAIL_SUCCESS = "DELETE_PROFILE_SURVEY_DETAIL_SUCCESS";

export const GET_PROFILE_NOTIFICATION_LIST_START = "GET_PROFILE_NOTIFICATION_LIST_START";
export const GET_PROFILE_NOTIFICATIONS_LIST_FAIL = "GET_PROFILE_NOTIFICATIONS_LIST_FAIL";
export const GET_PROFILE_NOTIFICATIONS_LIST_SUCCESS = "GET_PROFILE_NOTIFICATIONS_LIST_SUCCESS";
export const GET_PROFILE_NOTIFICATION_DETAIL_START = "GET_PROFILE_NOTIFICATION_DETAIL_START";
export const GET_PROFILE_NOTIFICATION_DETAIL_FAIL = "GET_PROFILE_NOTIFICATION_DETAIL_FAIL";
export const GET_PROFILE_NOTIFICATION_DETAIL_SUCCESS = "GET_PROFILE_NOTIFICATION_DETAIL_SUCCESS";
export const PUT_PROFILE_NOTIFICATION_LIST_START = "PUT_PROFILE_NOTIFICATION_LIST_START";
export const PUT_PROFILE_NOTIFICATION_LIST_FAIL = "PUT_PROFILE_NOTIFICATION_LIST_FAIL";
export const PUT_PROFILE_NOTIFICATION_LIST_SUCCESS = "PUT_PROFILE_NOTIFICATION_LIST_SUCCESS";
export const PUT_PROFILE_NOTIFICATION_DETAIL_START = "PUT_PROFILE_NOTIFICATION_DETAIL_START";
export const PUT_PROFILE_NOTIFICATION_DETAIL_FAIL = "PUT_PROFILE_NOTIFICATION_DETAIL_FAIL";
export const PUT_PROFILE_NOTIFICATION_DETAIL_SUCCESS = "PUT_PROFILE_NOTIFICATION_DETAIL_SUCCESS";
export const DELETE_PROFILE_NOTIFICATION_DETAIL_FAIL = "DELETE_PROFILE_NOTIFICATION_DETAIL_FAIL";
export const DELETE_PROFILE_NOTIFICATION_DETAIL_SUCCESS = "DELETE_PROFILE_NOTIFICATION_DETAIL_SUCCESS";

export const GET_PROFILE_MESSAGE_LIST_START = "GET_PROFILE_MESSAGE_LIST_START";
export const GET_PROFILE_MESSAGES_LIST_FAIL = "GET_PROFILE_MESSAGES_LIST_FAIL";
export const GET_PROFILE_MESSAGES_LIST_SUCCESS = "GET_PROFILE_MESSAGES_LIST_SUCCESS";
export const GET_PROFILE_MESSAGE_DETAIL_START = "GET_PROFILE_MESSAGE_DETAIL_START";
export const GET_PROFILE_MESSAGE_DETAIL_FAIL = "GET_PROFILE_MESSAGE_DETAIL_FAIL";
export const GET_PROFILE_MESSAGE_DETAIL_SUCCESS = "GET_PROFILE_MESSAGE_DETAIL_SUCCESS";
export const PUT_PROFILE_MESSAGE_LIST_START = "PUT_PROFILE_MESSAGE_LIST_START";
export const PUT_PROFILE_MESSAGE_LIST_FAIL = "PUT_PROFILE_MESSAGE_LIST_FAIL";
export const PUT_PROFILE_MESSAGE_LIST_SUCCESS = "PUT_PROFILE_MESSAGE_LIST_SUCCESS";
export const PUT_PROFILE_MESSAGE_DETAIL_START = "PUT_PROFILE_MESSAGE_DETAIL_START";
export const PUT_PROFILE_MESSAGE_DETAIL_FAIL = "PUT_PROFILE_MESSAGE_DETAIL_FAIL";
export const PUT_PROFILE_MESSAGE_DETAIL_SUCCESS = "PUT_PROFILE_MESSAGE_DETAIL_SUCCESS";
export const DELETE_PROFILE_MESSAGE_DETAIL_FAIL = "DELETE_PROFILE_MESSAGE_DETAIL_FAIL";
export const DELETE_PROFILE_MESSAGE_DETAIL_SUCCESS = "DELETE_PROFILE_MESSAGE_DETAIL_SUCCESS";

export const CREATE_INQUIRY_START = "CREATE_INQUIRY_START";
export const CREATE_INQUIRY_FAIL = "CREATE_INQUIRY_FAIL";
export const CREATE_INQUIRY_SUCCESS = "CREATE_INQUIRY_SUCCESS";

export const GET_INQUIRY_LIST_START = "GET_INQUIRY_LIST_START";
export const GET_INQUIRIES_LIST_FAIL = "GET_INQUIRIES_LIST_FAIL";
export const GET_INQUIRIES_LIST_SUCCESS = "GET_INQUIRIES_LIST_SUCCESS";

export const GET_INQUIRY_DETAIL_START = "GET_INQUIRY_DETAIL_START";
export const GET_INQUIRY_DETAIL_FAIL = "GET_INQUIRY_DETAIL_FAIL";
export const GET_INQUIRY_DETAIL_SUCCESS = "GET_INQUIRY_DETAIL_SUCCESS";

export const GET_PROFILE_INQUIRY_LIST_START = "GET_PROFILE_INQUIRY_LIST_START";
export const GET_PROFILE_INQUIRY_LIST_SUCCESS = "GET_PROFILE_INQUIRY_LIST_SUCCESS";
export const GET_PROFILE_INQUIRY_LIST_FAIL = "GET_PROFILE_INQUIRY_LIST_FAIL";
export const GET_PROFILE_INQUIRY_DETAIL_START = "GET_PROFILE_INQUIRY_DETAIL_START";
export const GET_PROFILE_INQUIRY_DETAIL_FAIL = "GET_PROFILE_INQUIRY_DETAIL_FAIL";
export const GET_PROFILE_INQUIRY_DETAIL_SUCCESS = "GET_PROFILE_INQUIRY_DETAIL_SUCCESS";
export const PUT_PROFILE_INQUIRY_DETAIL_START = "PUT_PROFILE_INQUIRY_DETAIL_START";
export const PUT_PROFILE_INQUIRY_DETAIL_FAIL = "PUT_PROFILE_INQUIRY_DETAIL_FAIL";
export const PUT_PROFILE_INQUIRY_DETAIL_SUCCESS = "PUT_PROFILE_INQUIRY_DETAIL_SUCCESS";
export const DELETE_PROFILE_INQUIRY_DETAIL_FAIL = "DELETE_PROFILE_INQUIRY_DETAIL_FAIL";
export const DELETE_PROFILE_INQUIRY_DETAIL_SUCCESS = "DELETE_PROFILE_INQUIRY_DETAIL_SUCCESS";

export const CREATE_INQUIRY_COMMENT_START = "CREATE_INQUIRY_COMMENT_START";
export const CREATE_INQUIRY_COMMENT_FAIL = "CREATE_INQUIRY_COMMENT_FAIL";
export const CREATE_INQUIRY_COMMENT_SUCCESS = "CREATE_INQUIRY_COMMENT_SUCCESS";

export const GET_INQUIRY_COMMENT_LIST_START = "GET_INQUIRY_COMMENT_LIST_START";
export const GET_INQUIRY_COMMENTS_LIST_FAIL = "GET_INQUIRY_COMMENTS_LIST_FAIL";
export const GET_INQUIRY_COMMENTS_LIST_SUCCESS = "GET_INQUIRY_COMMENTS_LIST_SUCCESS";

export const GET_INQUIRY_COMMENT_DETAIL_START = "GET_INQUIRY_COMMENT_DETAIL_START";
export const GET_INQUIRY_COMMENT_DETAIL_FAIL = "GET_INQUIRY_COMMENT_DETAIL_FAIL";
export const GET_INQUIRY_COMMENT_DETAIL_SUCCESS = "GET_INQUIRY_COMMENT_DETAIL_SUCCESS";

export const PUT_INQUIRY_COMMENT_START = "PUT_INQUIRY_COMMENT_START";
export const PUT_INQUIRY_COMMENT_FAIL = "PUT_INQUIRY_COMMENT_FAIL";
export const PUT_INQUIRY_COMMENT_SUCCESS = "PUT_INQUIRY_COMMENT_SUCCESS";

export const GET_PROFILE_SESSIONS_LIST_FAIL = "GET_PROFILE_SESSIONS_LIST_FAIL";
export const GET_PROFILE_SESSIONS_LIST_SUCCESS = "GET_PROFILE_SESSIONS_LIST_SUCCESS";
export const GET_PROFILE_SESSION_DETAIL_FAIL = "GET_PROFILE_SESSION_DETAIL_FAIL";
export const GET_PROFILE_SESSION_DETAIL_SUCCESS = "GET_PROFILE_SESSION_DETAIL_SUCCESS";
export const PUT_PROFILE_SESSION_DETAIL_FAIL = "PUT_PROFILE_SESSION_DETAIL_FAIL";
export const PUT_PROFILE_SESSION_DETAIL_SUCCESS = "PUT_PROFILE_SESSION_DETAIL_SUCCESS";
export const DELETE_PROFILE_SESSION_DETAIL_FAIL = "DELETE_PROFILE_SESSION_DETAIL_FAIL";
export const DELETE_PROFILE_SESSION_DETAIL_SUCCESS = "DELETE_PROFILE_SESSION_DETAIL_SUCCESS"

export const GET_PROFILE_WORKSHOP_LIST_FAIL = "GET_PROFILE_WORKSHOPS_LIST_FAIL";
export const GET_PROFILE_WORKSHOPS_LIST_FAIL = "GET_PROFILE_WORKSHOPS_LIST_FAIL";
export const GET_PROFILE_WORKSHOPS_LIST_SUCCESS = "GET_PROFILE_WORKSHOPS_LIST_SUCCESS";
export const GET_PROFILE_WORKSHOP_DETAIL_START = "GET_PROFILE_WORKSHOP_DETAIL_START";
export const GET_PROFILE_WORKSHOP_DETAIL_FAIL = "GET_PROFILE_WORKSHOP_DETAIL_FAIL";
export const GET_PROFILE_WORKSHOP_DETAIL_SUCCESS = "GET_PROFILE_WORKSHOP_DETAIL_SUCCESS";
export const PUT_PROFILE_WORKSHOP_DETAIL_START = "PUT_PROFILE_WORKSHOP_DETAIL_START";
export const PUT_PROFILE_WORKSHOP_DETAIL_FAIL = "PUT_PROFILE_WORKSHOP_DETAIL_FAIL";
export const PUT_PROFILE_WORKSHOP_DETAIL_SUCCESS = "PUT_PROFILE_WORKSHOP_DETAIL_SUCCESS";
export const DELETE_PROFILE_WORKSHOP_DETAIL_FAIL = "DELETE_PROFILE_WORKSHOP_DETAIL_FAIL";
export const DELETE_PROFILE_WORKSHOP_DETAIL_SUCCESS = "DELETE_PROFILE_WORKSHOP_DETAIL_SUCCESS";

export const GET_PROFILE_WORKSHOP_LIST_START = "GET_PROFILE_WORKSHOP_LIST_START";
export const GET_PROFILE_WORKSHOP_LIST_SUCCESS = "GET_PROFILE_WORKSHOP_LIST_SUCCESS";

export const GET_PROFILE_WORKSHOP_CONTENT_START = "GET_PROFILE_WORKSHOP_CONTENT_START";
export const GET_PROFILE_WORKSHOP_CONTENT_FAIL = "GET_PROFILE_WORKSHOP_CONTENT_FAIL";
export const GET_PROFILE_WORKSHOP_CONTENT_SUCCESS = "GET_PROFILE_WORKSHOP_CONTENT_SUCCESS";

export const GET_PROFILE_RWORKSHOP_LIST_START = "GET_PROFILE_RWORKSHOP_LIST_START";
export const GET_PROFILE_RWORKSHOP_LIST_SUCCESS = "GET_PROFILE_RWORKSHOP_LIST_SUCCESS";
export const GET_PROFILE_RWORKSHOP_LIST_FAIL = "GET_PROFILE_RWORKSHOP_LIST_FAIL";
export const GET_PROFILE_RWORKSHOP_CONTENT_START = "GET_PROFILE_RWORKSHOP_CONTENT_START";
export const GET_PROFILE_RWORKSHOP_CONTENT_FAIL = "GET_PROFILE_RWORKSHOP_CONTENT_FAIL";
export const GET_PROFILE_RWORKSHOP_CONTENT_SUCCESS = "GET_PROFILE_RWORKSHOP_CONTENT_SUCCESS";

export const PUT_PROFILE_WORKSHOP_CONTENT_START = "PUT_PROFILE_WORKSHOP_CONTENT_START";
export const PUT_PROFILE_WORKSHOP_CONTENT_FAIL = "PUT_PROFILE_WORKSHOP_CONTENT_FAIL";
export const PUT_PROFILE_WORKSHOP_CONTENT_SUCCESS = "PUT_PROFILE_WORKSHOP_CONTENT_SUCCESS";

export const GET_USER_COLLABORATION_LIST_START = "GET_USER_COLLABORATION_LIST_START";
export const GET_USER_COLLABORATION_LIST_FAIL = "GET_USER_COLLABORATION_LIST_FAIL";
export const GET_USER_COLLABORATION_LIST_SUCCESS = "GET_USER_COLLABORATION_LIST_SUCCESS";
export const PUT_USER_COLLABORATION_START = "PUT_USER_COLLABORATION_START";
export const PUT_USER_COLLABORATION_FAIL = "PUT_USER_COLLABORATION_FAIL";
export const PUT_USER_COLLABORATION_SUCCESS = "PUT_USER_COLLABORATION_SUCCESS";
